"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmenuWrapper = exports.SubmenuContainer = exports.MenuGroupContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const submenuMouseLeaveOffset = 10;
const MenuGroupContainer = exports.MenuGroupContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuGroupContainer",
  componentId: "sc-1hhnl5j-0"
})(["cursor:pointer;", " &:hover{background-color:", ";}"], ({
  isPopoverOpen
}) => isPopoverOpen && (0, _styledComponents.css)(["background-color:", ";"], ({
  theme
}) => theme.colors.appFrame.menu.itemHoverBg), ({
  theme
}) => theme.colors.appFrame.menu.itemHoverBg);
const SubmenuContainer = exports.SubmenuContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__SubmenuContainer",
  componentId: "sc-1hhnl5j-1"
})(["background-color:", ";position:fixed;list-style:none;width:", ";left:", ";box-shadow:0 3px 5px 0 ", ";overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;z-index:300;"], ({
  theme
}) => theme.colors.appFrame.menu.groupBg, ({
  theme
}) => theme.AppFrame.menu.submenu.width, ({
  theme
}) => theme.AppFrame.menu.expandedWidth, ({
  theme
}) => theme.colors.appFrame.menu.switcherShadow);
const SubmenuWrapper = exports.SubmenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__SubmenuWrapper",
  componentId: "sc-1hhnl5j-2"
})(["position:fixed;z-index:300;width:", "px;left:", "px;border:", "px solid transparent;"], ({
  theme
}) => parseInt(theme.AppFrame.menu.submenu.width, 10) + 2 * submenuMouseLeaveOffset, ({
  leftOffset
}) => leftOffset - submenuMouseLeaveOffset, submenuMouseLeaveOffset);